import { render, staticRenderFns } from "./FiltroDescuentosClientes.vue?vue&type=template&id=bbcc0e78"
import script from "./FiltroDescuentosClientes.vue?vue&type=script&lang=js"
export * from "./FiltroDescuentosClientes.vue?vue&type=script&lang=js"
import style0 from "./FiltroDescuentosClientes.vue?vue&type=style&index=0&id=bbcc0e78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports